var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "400px",
    height: "400px",
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "day") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "day"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F8BB1C",
    cx: 200,
    cy: 200,
    r: 200
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.714039,156.015806 C134.301722,156.015806 149.916597,147.706222 160.604752,135.609251 C169.467269,125.578557 171.323692,117.249413 167.635153,115.563139 C165.097978,114.403228 163.990333,114.929641 161.200089,118.808975 C160.34905,119.992193 155.897195,126.95682 154.381776,129.0793 C145.878451,140.988965 135.675357,147.347837 119.714039,147.347837 C103.752721,147.347837 93.5496263,140.988965 85.0463011,129.0793 C83.530882,126.95682 79.0790279,119.992193 78.2279883,118.808975 C75.4377447,114.929641 74.3300998,114.403228 71.7929243,115.563139 C68.1043853,117.249413 69.9608088,125.578557 78.8233257,135.609251 C89.5114802,147.706222 105.126355,156.015806 119.714039,156.015806 Z",
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 10,
    transform: "translate(119.714039, 135.507903) scale(1, -1) translate(-119.714039, -135.507903) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.714039,156.015806 C294.301722,156.015806 309.916597,147.706222 320.604752,135.609251 C329.467269,125.578557 331.323692,117.249413 327.635153,115.563139 C325.097978,114.403228 323.990333,114.929641 321.200089,118.808975 C320.34905,119.992193 315.897195,126.95682 314.381776,129.0793 C305.878451,140.988965 295.675357,147.347837 279.714039,147.347837 C263.752721,147.347837 253.549626,140.988965 245.046301,129.0793 C243.530882,126.95682 239.079028,119.992193 238.227988,118.808975 C235.437745,114.929641 234.3301,114.403228 231.792924,115.563139 C228.104385,117.249413 229.960809,125.578557 238.823326,135.609251 C249.51148,147.706222 265.126355,156.015806 279.714039,156.015806 Z",
    id: "Oval-Copy",
    stroke: "#000000",
    strokeWidth: 10,
    transform: "translate(279.714039, 135.507903) scale(1, -1) translate(-279.714039, -135.507903) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0845919,205.000028 C57.7198174,282.766136 121.59216,345 200,345 C278.40784,345 342.280183,282.766136 344.915408,205.000028 L55.084591,205 Z",
    id: "Combined-Shape",
    stroke: "#000000",
    strokeWidth: 10,
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayIcon);
export default __webpack_public_path__ + "static/media/day-icon.adb64199.svg";
export { ForwardRef as ReactComponent };